module.exports = __webpack_public_path__ + "static/media/open_shop.44b0c6a2.png";